module.exports = __webpack_public_path__ + "img/review.f9127084.png";